import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import ListIcon from '@mui/icons-material/List';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { Theme, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { BooleanField, BooleanInput, Button, Create, Datagrid, DateTimeInput, Edit, EditButton, FormDataConsumer, FormTab, NumberField, NumberInput, Show, ShowActions, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, TopToolbar, required, usePermissions, useRecordContext, useResourceDefinition, useTranslate } from 'react-admin';
import { Link, useParams } from 'react-router-dom';
import ContentNode from 'utils/GeneratedModels/ContentNode';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
import BlocksInput from 'utils/react-admin/inputs/BlocksInput';
import ArrayForm from 'utils/react-admin/inputs/BlocksInput/ArrayForm';
import ContentTypeInput from 'utils/react-admin/inputs/ContentTypeInput';
import FileManagerModalInput from 'utils/react-admin/inputs/FileManagerModalInput';
import RichTextInputEx from 'utils/react-admin/inputs/RichTextInputEx';
import TreeList, { TreeNode } from 'utils/react-admin/lists/TreeList';
import { Permissions } from '../../ra-php-crud-api-auth';

export const CHOICES_CONTENT_NODE_CONTENT_TYPE = [
  { id: 'blocks', name: 'blocks', },
  { id: 'records', name: 'records', },
  { id: 'redirect', name: 'redirect', },
  { id: 'program', name: 'program', },
  { id: 'frontend_effect', name: 'frontend_effect', },
];
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <BooleanInput source="is_public" fullWidth />,
  <NumberInput source="tree_node_parent_id" fullWidth />,
  <NumberInput source="tree_node_parent_order" fullWidth />,
  <TextInput source="tree_node_alias" fullWidth />,
  <TextInput source="old_content_en" fullWidth />,
  <TextInput source="old_content_tc" fullWidth />,
  <TextInput source="old_content_sc" fullWidth />,
  // <SelectInput source="content_type" fullWidth choices={CHOICES_CONTENT_NODE_CONTENT_TYPE} />,
  // <TextInput source="content_type_data" fullWidth />,
  <TextInput source="title_en" fullWidth />,
  <TextInput source="title_tc" fullWidth />,
  <TextInput source="title_sc" fullWidth />,
  <TextInput source="content_en" fullWidth />,
  <TextInput source="content_tc" fullWidth />,
  <TextInput source="content_sc" fullWidth />,
  <DateTimeInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateTimeInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

const validateIsPublic: any[] = [required()];
const validateTreeNodeParentId: any[] = [];
const validateTreeNodeParentOrder: any[] = [];
const validateTreeNodeAlias: any[] = [];
// const validateOldContentEn: any[] = [];
// const validateOldContentTc: any[] = [];
// const validateOldContentSc: any[] = [];
// const validateContentType: any[] = [];
// const validateContentTypeData: any[] = [];
const validateTitleEn: any[] = [];
const validateTitleTc: any[] = [];
const validateTitleSc: any[] = [];
// const validateContentEn: any[] = [];
// const validateContentTc: any[] = [];
// const validateContentSc: any[] = [];
// const validateImageArray: any[] = [];
// const validateImageCaptionArray: any[] = [];

const EditActions = () => {
  const record = useRecordContext();
  const translate = useTranslate();
  if (undefined === record) {
    return null;
  }
  // console.log(record.url_path);
  return (
  <TopToolbar>
      {/* <Button color="primary" onClick={() => window.open(`https://spga.org.hk/${record.old_url_path}`)} label={`${translate("ra.action.show")} Old`}><RemoveRedEyeIcon /></Button> */}
      <Button color="primary" onClick={() => window.open(`/en${record.url_path}`)} label={`${translate("ra.action.show")} EN`}><RemoveRedEyeIcon /></Button>
      <Button color="primary" onClick={() => window.open(`/tc${record.url_path}`)} label={`${translate("ra.action.show")} TC`}><RemoveRedEyeIcon /></Button>
      <Button color="primary" onClick={() => window.open(`/sc${record.url_path}`)} label={`${translate("ra.action.show")} SC`}><RemoveRedEyeIcon /></Button>
  </TopToolbar>
  )
}

const TreeNodeListItem = (node: TreeNode<ContentNode>) =>
  <div>
    <Typography variant="body2" component="span">
      {node.title_en ? node.title_en : "-- Root --"}
    </Typography>
    <span style={{ paddingLeft: 2, paddingRight: 2 }}>/</span>
    <Typography variant="body2" component="span">
      {node.title_tc ? node.title_tc : ""}
    </Typography>
    <span style={{ paddingLeft: 2, paddingRight: 2 }}>/</span>
    <Typography variant="body2" component="span">
      {node.title_sc ? node.title_sc : ""}
    </Typography>
    <span style={{ paddingLeft: 2, paddingRight: 2 }}>/</span>
    <a href={`/en${node.url_path}`} target="_blank" rel="noreferrer">EN</a>
    <span style={{ paddingLeft: 2, paddingRight: 2 }}>/</span>
    <a href={`/tc${node.url_path}`} target="_blank" rel="noreferrer">TC</a>
    <span style={{ paddingLeft: 2, paddingRight: 2 }}>/</span>
    <a href={`/sc${node.url_path}`} target="_blank" rel="noreferrer">SC</a>
  </div>

const TreeNodeListItemButtons = (node: TreeNode<ContentNode>) => {
  let recordsListUrl: any = '';
  if ('records' === node.content_type) {
    if (node.content_type_data) {
      if (node.content_type_data.filter) {
        console.log(node.content_type_data.filter);
        recordsListUrl = { pathname: `/${node.content_type_data.id}`, search: `filter=${JSON.stringify(node.content_type_data.filter)}` }
      } else {
        recordsListUrl = `/${node.content_type_data.id}`;
      }
    }
  }
  return <>
    <Link to={`/content-node-meta/edit/${node.id}`}><Button label="Meta"><DescriptionIcon /></Button></Link>
    {'blocks' === node.content_type
      ? <Link to={`/content_node/${node.id}`}><Button label="Edit"><EditIcon /></Button></Link>
      : 'records' === node.content_type
        ? <Link to={recordsListUrl}><Button label="List"><ListIcon /></Button></Link>
        : null
    }
  </>
}

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <TreeList filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }}
      listItem={TreeNodeListItem}
      listItemButtons={TreeNodeListItemButtons}
    >
      {isSmall ? (
        <SimpleList linkType="edit" primaryText={(record: any) => record.id}></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <BooleanField source="is_public" fullWidth />
            <BooleanField source="is_menu" fullWidth />
            <NumberField source="tree_node_parent_id" fullWidth />
            <NumberField source="tree_node_parent_order" fullWidth />
            <TextField source="tree_node_alias" fullWidth />
            <TextField source="content_type" fullWidth />
            {/* <ArrayField source="image_array"><SimpleFormIterator><FileManagerModalField source="image" /></SimpleFormIterator></ArrayField>
            <ArrayField source="image_caption_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField> */}
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </TreeList>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <BooleanField source="is_public" fullWidth />
        <NumberField source="tree_node_parent_id" fullWidth />
        <NumberField source="tree_node_parent_order" fullWidth />
        <TextField source="tree_node_alias" fullWidth />
        <TextField source="old_content_en" fullWidth />
        <TextField source="old_content_tc" fullWidth />
        <TextField source="old_content_sc" fullWidth />
        <TextField source="content_type" fullWidth />
        <TextField source="content_type_data" fullWidth />
        <TextField source="title_en" fullWidth />
        <TextField source="title_tc" fullWidth />
        <TextField source="title_sc" fullWidth />
        <TextField source="content_en" fullWidth />
        <TextField source="content_tc" fullWidth />
        <TextField source="content_sc" fullWidth />
        {/* <ArrayField source="image_array"><SimpleFormIterator><FileManagerModalField source="image" /></SimpleFormIterator></ArrayField>
        <ArrayField source="image_caption_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField> */}
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transformMeta = (data: any) => {
  data.image_array = ('string' === typeof data.image_array) ? data.image_array : (null === data.image_array ? null : JSON.stringify(data.image_array));;
  data.image_caption_array = ('string' === typeof data.image_caption_array) ? data.image_caption_array : (null === data.image_caption_array ? null : JSON.stringify(data.image_caption_array));;
  data.mobile_section_image = ('string' === typeof data.mobile_section_image) ? data.mobile_section_image : (null === data.mobile_section_image ? null : JSON.stringify(data.mobile_section_image));;
  data.content_type_data = ('string' === typeof data.content_type_data) ? data.content_type_data : (null === data.content_type_data ? null : JSON.stringify(data.content_type_data));;
  delete data.content_data;
  return data;
}

const transform = (data: any) => {
  console.log('transform', data);
  // data.image_array = JSON.stringify(data.image_array);
  // data.image_caption_array = JSON.stringify(data.image_caption_array);
  delete data.image_array;
  delete data.image_caption_array;
  data.content_type_data = ('string' === typeof data.content_type_data) ? data.content_type_data : JSON.stringify(data.content_type_data);
  data.content_data = ('string' === typeof data.content_data) ? data.content_data : (null === data.content_data ? null : JSON.stringify(data.content_data));
  // data.content_en = data.content_en ? JSON.stringify(data.content_en) : null;
  // data.content_tc = data.content_tc ? JSON.stringify(data.content_tc) : null;
  // data.content_sc = data.content_sc ? JSON.stringify(data.content_sc) : null;
  return data;
};

export const ContentNodeMetaForm = () => {
  return (
    <TabbedForm>
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={2}><BooleanInput source="is_public" fullWidth validate={validateIsPublic} /></Grid>
          <Grid item xs={2}><BooleanInput source="is_menu" fullWidth validate={validateIsPublic} /></Grid>
          <Grid item xs={2}><NumberInput source="tree_node_parent_id" fullWidth validate={validateTreeNodeParentId} /></Grid>
          <Grid item xs={2}><NumberInput source="tree_node_parent_order" fullWidth validate={validateTreeNodeParentOrder} /></Grid>
          <Grid item xs={4}><TextInput source="tree_node_alias" fullWidth validate={validateTreeNodeAlias} /></Grid>
          <Grid item xs={4}><TextInput source="title_en" fullWidth validate={validateTitleEn} /></Grid>
          <Grid item xs={4}><TextInput source="title_tc" fullWidth validate={validateTitleTc} /></Grid>
          <Grid item xs={4}><TextInput source="title_sc" fullWidth validate={validateTitleSc} /></Grid>
        </GridWrapper>
        <ContentTypeInput source="content_type" />
      </FormTab>
      <FormTab label="Session Images">
        <FileManagerModalInput source="mobile_section_image" mode="image" fullWidth />
        <ArrayForm source="image_array">
          <FileManagerModalInput source="image" hideLabel={true} mode="image" />
        </ArrayForm>
        <RichTextInputEx source="image_caption_en_html"></RichTextInputEx>
        <RichTextInputEx source="image_caption_tc_html"></RichTextInputEx>
        <RichTextInputEx source="image_caption_sc_html"></RichTextInputEx>
      </FormTab>
    </TabbedForm>)
}
export const ContentNodeMetaFormCreate = () => {
  return <Create mutationMode="pessimistic" transform={transformMeta}><ContentNodeMetaForm /></Create>;
}
export const ContentNodeMetaFormEdit = () => {
  const { id } = useParams();
  return <Edit mutationMode="pessimistic" actions={<EditActions/>} transform={transformMeta} resource="content_node" id={id} redirect={false}><ContentNodeMetaForm /></Edit>;
}
export const PageContentNodeMeta = () => {
  const { mode } = useParams();
  return (
    <Box mt={2}>
      <Paper>
        {'edit' === mode ? <ContentNodeMetaFormEdit /> : <ContentNodeMetaFormCreate />}
      </Paper>
    </Box>
  )
}

export const ResourceForm = ({ isEdit }: { isEdit?: boolean }) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={4}><TextInput source="title_en" fullWidth validate={validateTitleEn} /></Grid>
          <Grid item xs={4}><TextInput source="title_tc" fullWidth validate={validateTitleTc} /></Grid>
          <Grid item xs={4}><TextInput source="title_sc" fullWidth validate={validateTitleSc} /></Grid>
        </GridWrapper>
        <FormDataConsumer>{({ formData }) => {
          console.log(formData);
          if ("blocks" === formData.content_type) {
            return <>
              <BlocksInput source="content_data" configSource="content_type_data" />
            </>
          }
        }}</FormDataConsumer>
      </FormTab>

    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform} redirect={false}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform} redirect={false} actions={<EditActions/>}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: AccountTreeIcon,
}

export default Resource;
